var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashboard",
    transform: "translate(0 -528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5326",
    "data-name": "Group 5326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 128,
    height: 128,
    transform: "translate(0 528)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-708.662 -885.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M48.585,0H9.192A9.2,9.2,0,0,0,0,9.192V32.828A9.2,9.2,0,0,0,9.192,42.02H48.585a9.2,9.2,0,0,0,9.193-9.193V9.192A9.2,9.2,0,0,0,48.585,0Zm0,0",
    transform: "translate(709.632 1414.474)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M48.585,213.332H9.192A9.2,9.2,0,0,0,0,222.525v55.151a9.2,9.2,0,0,0,9.192,9.192H48.585a9.2,9.2,0,0,0,9.193-9.192V222.525A9.2,9.2,0,0,0,48.585,213.332Zm0,0",
    transform: "translate(709.632 1253.667)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M325.919,341.332H286.525a9.2,9.2,0,0,0-9.192,9.193v23.636a9.2,9.2,0,0,0,9.192,9.192h39.394a9.2,9.2,0,0,0,9.192-9.192V350.525A9.2,9.2,0,0,0,325.919,341.332Zm0,0",
    transform: "translate(500.582 1157.181)",
    fill: "#90205d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M325.919,0H286.525a9.2,9.2,0,0,0-9.192,9.192V64.343a9.2,9.2,0,0,0,9.192,9.193h39.394a9.2,9.2,0,0,0,9.192-9.193V9.192A9.2,9.2,0,0,0,325.919,0Zm0,0",
    transform: "translate(500.582 1414.474)",
    fill: "#90205d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.067de095.svg";
export { ForwardRef as ReactComponent };